import { sentry, object, constants } from 'common/helpers'
import cookie from 'js-cookie'


const whitelistModelsKeys = [
  'me',
  'cart',
  'queue',
  'modals',
  'payment',
  'subscription',
  'recommendations',
]

const whitelistViewKeys = [
  'cancelSubscriptionPage',
  'collectionPage',
  'fragranceOfTheMonthPage',
  'paymentPage',
  'pickPage',
  'productPage',
  'profilePage',
  'smartSearchPage',
  'trackingPage',
  'thankYouPage',
  'paymentPageNew',
  'subscribePrototypePage',
]

const getValidCookies = (cookies) => (
  Object.values(cookies).reduce((acc, value) => (
    typeof value === 'string'
      ? [ ...acc, value ]
      : [ ...acc, ...getValidCookies(value) ]
  ), [])
)

const validCookieNames = [
  ...getValidCookies(constants.cookieNames),
  'scnt_utm_campaign',
  'scnt_utm_content',
  'scnt_utm_medium',
  'scnt_utm_source',
]

const validAbTests      = Object.values(constants.abTests)
const validFeatures     = Object.values(constants.features)
const validStorageNames = Object.values(constants.localStorageNames)

const getCookies = () => {
  const cookies = cookie.getJSON()

  return Object.keys(cookies).reduce((acc, name) => {
    const isValid = validCookieNames.includes(name)

    return isValid
      ? { ...acc, [name]: cookies[name] }
      : acc
  }, {})
}

const getFeatures = (features) => (
  JSON.stringify(Object.keys(features).reduce((acc, name) => {
    const isValid = validFeatures.includes(name) && features[name]

    return isValid
      ? [ ...acc, name ]
      : acc
  }, []))
)

const getAbTests = (abTests) => (
  JSON.stringify(Object.keys(abTests).reduce((acc, name) => {
    const value   = abTests[name].value
    const isValid = value !== 'a' && validAbTests.includes(name)

    return isValid
      ? [ ...acc, `${name}(${value})` ]
      : acc
  }, []), null, ' ')
)

const getStorageItems = (storage) => {

  if (!storage) {
    return 'storage is null'
  }

  return (
    Object.keys(storage).reduce((acc, name) => {
      const isValid = validStorageNames.includes(name)

      if (!isValid) {
        return acc
      }

      let value = null

      try {
        value = JSON.parse(storage.getItem(name))
      }
      catch (err) {
        value = 'JSON parse error'
      }

      return ({
        ...acc,
        [name]: value,
      })
    }, {})
  )
}

// hides data that you do not need
const addWrapper = (data) => ({ data })

const sentryMiddleware = () => (store) => {
  // let lastAction

  sentry.addEventProcessor((event = {}) => {
    const state = store.getState()
    const { abTests, features } = window.__globals__

    try {
      event.extra = {
        // lastAction,
        'state.misc': state.misc,
        'state.models': addWrapper(object.filterByKeyList(state.models, whitelistModelsKeys)),
        'state.view': addWrapper(object.filterByKeyList(state.view, whitelistViewKeys)),
        'state.routing': addWrapper(state.routing),
        cookies: addWrapper(getCookies()),
        activeAbTests: getAbTests(abTests),
        activeFeatures: getFeatures(features),
        localStorage: addWrapper(getStorageItems(localStorage)),
        sessionStorage: addWrapper(getStorageItems(sessionStorage)),
        ...(event.extra || {}),
      }
    }
    catch (err) {
      console.error(err)
    }

    return event
  })

  return (next) => (action) => {
    sentry.captureBreadcrumb({
      category: 'redaction-action',
      message: action.type,
      data: action.payload,
    })

    // lastAction = action
    return next(action)
  }
}


export default sentryMiddleware
